<template lang="pug">
.caroucel-background
    v-container.default-container
        div(style="margin-bottom: 3.75em")
            h2 Protect your customers,<br/>
                | streamline your bussiness

            p Ticketeer combines traditional event ticket sales organization with security benefits of blockchain.
            p Our innovative smart contracts provide free and straightforward way to back your event with blockchain technology.
        div(style="height: 344px; overflow: hidden")
          .wrap
              tiny-slider(:mouse-drag="true" :loop="true" 
                      :autoplay="true" :lazyload="false" navPosition="bottom" 
                      :rewind="false"
                      :fixedWidth="4" :speed="1000" :autoplay-timeout="2500" items="1" gutter="20")

                  img(v-for="slide in slides" width="200" height="250" :alt="slide.alt" :src="slide.img")
</template>

<script>
import { Carousel3d, Slide } from "vue-carousel-3d";

import VueTinySlider from './slider';

export default {
  name: "Caroucel",

  data: () => ({
    slides: [
      { img: require("../assets/img/caroucel/small concert.png"), alt: "Small Concert" },
      { img: require("../assets/img/caroucel/guitar.png"), alt: "Guitarist in front of audience" },
      { img: require("../assets/img/caroucel/concert.png"), alt: "Music Festival" },
      { img: require("../assets/img/caroucel/show.png"), alt: "Light show" },
      { img: require("../assets/img/caroucel/ballet.png"), alt: "Ballet performance" },
      { img: require("../assets/img/caroucel/presentation.png"), alt: "Ted talk" },
      { img: require("../assets/img/caroucel/box.png"), alt: "Box match" },
      { img: require("../assets/img/caroucel/football.png"), alt: "Soccer match" },
      { img: require("../assets/img/caroucel/cosplay.png"), alt: "Cosplay" },
    ]
  }),
  components: {
    Carousel3d,
    Slide,
    'tiny-slider': VueTinySlider
  }
};
</script>

<style lang="stylus" scoped>
.default-container {
  h2 {
    color: white;
  }

  p {
    color: white;
  }

  text-align: center;
}

.wrap 
  position absolute
  width calc(100vw - 5px)
  max-width calc(100vw - 5px)
  height 274px
  left: 5px
  overflow hidden !important

.caroucel-background {
  background-color: #718CD1;
}

</style>
